import { Address } from "viem";
import { useAccount } from "wagmi";
import { GRAPHQL_URL } from "~/core/constants";
import { useModal } from "~/core/contexts/ModalContext";
import useSWR from "swr";
import { api, BlinkoGame } from "../api";
import { ClaimModal } from "../modals/claim.modal";
import { RESOLVER_ADDRESS } from "../constants";

type SubgraphActiveGame = {
  id: string;
}

type QueryResult = {
  games: SubgraphActiveGame[];
}

const fetchUserActiveGames = async (address: Address): Promise<QueryResult> => {
  try {
    const responseSubgraph = await fetch(GRAPHQL_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: `
            query {
            games (
                where: {
                player: "${address.toLowerCase()}",
                status: Active,
                resolver: "${RESOLVER_ADDRESS.toLowerCase()}",
                }
            ) {
                id
            }
            }
        `
      }),
    });

    const { data } = await responseSubgraph.json();

    return {
      games: data.games || [],
    };
  } catch (e) {
    console.error(e);
    return { games: [] };
  }
};

export const PlayResultHandler = () => {
  const { address } = useAccount();
  const { showModal } = useModal();

  const fetch = async () => {
    if (!address) {
      return null;
    }

    const data = await fetchUserActiveGames(address);

    if (!data || data.games.length === 0) {
      return;
    }

    const activeGameIds = data.games.map(g => g.id);
    const claimable: BlinkoGame[] = [];

    await Promise.all(activeGameIds.map(async (id) => {
      try {
        const game = await api.getGame(id);
        if (game.status === 'active') { 
        } else if (game.status === 'won') {
          claimable.push(game);
        }
      } catch (e) {
      }
    }));

    if (claimable.length > 0 && claimable.some(x => x.status === 'won')) {
      showModal((hide) => (
        <ClaimModal
          games={claimable}
          onDismiss={hide}
        />
      ), { hideOnEscapeKey: false });
      return;
    }
  };

  useSWR([address], fetch, {
    revalidateOnFocus: false,
    revalidateOnMount: true,
    refreshInterval: 0,
  });

  return (
    <>
    </>
  );
};
